
import { BankInfo } from './types';

export const WEDDING_DATE = new Date('2026-04-18T15:30:00');

export const NAMES = {
  groom: "Samuel Morla",
  bride: "Crismeri Evangelista"
};

export const QUOTE = "Aunque seamos diferentes siempre nos encontraremos donde dos mundos chocan";

export const BANK_ACCOUNTS: BankInfo[] = [
  {
    owner: "Samuel Morla Casey",
    bank: "Banco BHD",
    account: "36684230016"
  },
  {
    owner: "Samuel Morla Casey",
    bank: "Banco Popular",
    account: "815509104"
  },
  {
    owner: "Crismeri Evangelista",
    bank: "Banreservas",
    account: "9604285584"
  }
];

export const GOOGLE_MAPS_URL = "https://maps.google.com?q=FP5V+Q39%20Seminario%20Menor%20San%20Pedro%20Ap%C3%B3stol,%20San%20Pedro%20de%20Macor%C3%ADs%2021000&ftid=0x8eaf5e69708ebcf1:0xa2664ebd9683b06d&entry=gps&shh=CAE&lucs=,94297699,94275415,94284463,94231188,94280568,47071704,94218641,94282134,94286869&g_st=iw";

export const WHATSAPP_NUMBER = "8293650173";

export const IMAGES = {
  hero: "https://mediaexperto.com/temp/recursos/hero.jpg",
  interstitial: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?auto=format&fit=crop&q=80&w=1000",
  envelope: "https://mediaexperto.com/temp/recursos/envelope.png",
  gallery: [
  /*  "https://mediaexperto.com/temp/recursos/1.jpg",*/
    "https://mediaexperto.com/temp/recursos/2.jpg",
    "https://mediaexperto.com/temp/recursos/3.jpg",
    "https://mediaexperto.com/temp/recursos/4.jpg",
    "https://mediaexperto.com/temp/recursos/5.jpg"
  ]
};

export const SONG_DETAILS = {
  title: "Se van las horas",
  artist: "Musiko",
  url: "https://mediaexperto.com/temp/recursos/musiko.mp3"
};

export const MUSIC_URL = SONG_DETAILS.url;
